export default __webpack_public_path__ + "static/media/Group 14.87d2c88b.svg";